// Datadog browser-intake host per Datadog site. Shared by every path that posts
// to the browser intake directly (mobile uncorrelated logs) or relays to it
// (the RUM intake proxy), so a site added here reaches both.
export const INTAKE_BY_SITE: Readonly<Record<string, string>> = {
  'datadoghq.com': 'browser-intake-datadoghq.com',
  'us3.datadoghq.com': 'browser-intake-us3-datadoghq.com',
  'us5.datadoghq.com': 'browser-intake-us5-datadoghq.com',
  'datadoghq.eu': 'browser-intake-datadoghq.eu',
  'ap1.datadoghq.com': 'browser-intake-ap1-datadoghq.com',
};

export function intakeHostForSite(site: string): string | undefined {
  return Object.hasOwn(INTAKE_BY_SITE, site) ? INTAKE_BY_SITE[site] : undefined;
}
